var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextGroup"},[_c('p',{staticClass:"TextGroup__label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"TextGroup__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }